// @ts-check
// Tipo de cada evento da timeline para escolher a frase e o link (doc 10, seções 8.2 e 8.5): conversa, agenda, anexo,
// nota ou tarefa vinculada, ou o próprio registro.

/**
 * @typedef {{ name?: string | null, linkedObjectNameSingular?: string | null, linkedRecordId?: string | null, properties?: any }} TimelineEventLike
 * @typedef {{ kind: 'conversation' | 'calendar' | 'attachment' | 'activity' | 'record', action: string, objectNameSingular: string }} TimelineEventKind
 */

const ACTIVITY_OBJECT_NAMES = new Set(['note', 'task']);

/**
 * @param {TimelineEventLike} event
 * @returns {TimelineEventKind}
 */
export function classifyTimelineEvent(event) {
  const [objectNameSingular = '', action = ''] = String(event.name ?? '').split('.');
  if (objectNameSingular === 'message' || event.linkedObjectNameSingular === 'messageThread') return { kind: 'conversation', action, objectNameSingular };
  if (objectNameSingular === 'calendarEvent' || event.linkedObjectNameSingular === 'calendarEvent') return { kind: 'calendar', action, objectNameSingular };
  if (objectNameSingular === 'attachment') return { kind: 'attachment', action, objectNameSingular };
  if (ACTIVITY_OBJECT_NAMES.has(objectNameSingular) && event.linkedRecordId) return { kind: 'activity', action, objectNameSingular };
  return { kind: 'record', action, objectNameSingular };
}

/**
 * Caminho que o evento abre: a conversa, o dia na agenda, a aba de arquivos ou a nota e a tarefa.
 * @param {TimelineEventLike} event @param {{ targetObjectNameSingular: string, targetRecordId: string }} target
 * @returns {string | null}
 */
export function getTimelineEventLink(event, target) {
  const { kind, objectNameSingular } = classifyTimelineEvent(event);
  const properties = event.properties ?? {};
  switch (kind) {
    case 'conversation':
      return properties.threadId ? `/conversations/${properties.threadId}` : null;
    case 'calendar':
      return typeof properties.startsAt === 'string' ? `/calendar?date=${properties.startsAt.slice(0, 10)}` : '/calendar';
    case 'attachment':
      return `/object/${target.targetObjectNameSingular}/${target.targetRecordId}#files`;
    case 'activity':
      return event.linkedRecordId ? `/object/${objectNameSingular}/${event.linkedRecordId}` : null;
    default:
      return null;
  }
}
